module.exports = __webpack_public_path__ + "img/iphone-map-FRANCE-en.c0a85388.png";